import FullWidthSection from "./section/FullWidthSection";
import HorizontalDivider from "./HorizontalDivider";
import { Link } from "gatsby-link";
import useBotOnButton from "../../../src/_hooks/useBotOnButton";

const FooterAccenture = () => {
	const { trigger } = useBotOnButton("get-in-touch");

	return (
		<FullWidthSection className="pb-8 pb-md-15">
			<HorizontalDivider dashed={true} />
			<div className="d-flex justify-content-between align-items-stretch mx-auto" style={{ maxWidth: 530 }}>
				<ul className="list-unstyled font-size-medium">
					<li className="mb-6 font-weight-bold text-uppercase">Programmes</li>
					<li className="mb-5">
						<Link to="/thrive" className="text-no-underline text-underline-hover text-purple-semi-mid">
							Thrive
						</Link>
					</li>
					<li className="mb-5">
						<Link
							to="/launchpad/digital-marketing/"
							className="text-no-underline text-underline-hover text-purple-semi-mid"
						>
							Launchpad: Digital Marketer
						</Link>
					</li>
					<li>
						<Link to="/" className="text-no-underline text-underline-hover text-purple-semi-mid">
							Home
						</Link>
					</li>
				</ul>
				<ul className="list-unstyled font-size-medium">
					<li className="mb-6 font-weight-bold text-uppercase">Help</li>
					<li className="mb-5">
						<span
							className="text-no-underline text-underline-hover cursor-pointer text-purple-semi-mid"
							onClick={trigger}
						>
							Contact us
						</span>
					</li>
					<li className="mb-5">
						<Link to="/terms-and-conditions/" className="text-no-underline text-underline-hover text-purple-semi-mid">
							Terms & Conditions
						</Link>
					</li>
					<li>
						<Link to="/privacy-policy/" className="text-no-underline text-underline-hover text-purple-semi-mid">
							Privacy Policy
						</Link>
					</li>
				</ul>
			</div>
		</FullWidthSection>
	);
};

export default FooterAccenture;
